module.exports = __webpack_public_path__ + "static/media/recueil_default.b0dfee4f.png";